import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    detail: [],
    masterImport: null,
    loading: false,
    loadingUsers: false,
    error: null,
    contacts: [],
    users: [],
    detailTotal: 0,
});

const actions = {
    async importRead({commit}, id){
        try {
            commit('importReadBegin');
            const response = await DataService.get(`/imports/${id}`);
            commit('importReadSuccess', response.data.data);
        } catch (err) {
            commit('importReadErr', err);
        }
    },

    async importContactReadAll({commit}, id) {
        try {
            await commit('importContactReadAllBegin');
            const response = await DataService.get(`/contacts/import/${id}`);
            await commit('importContactReadAllSuccess', response.data.data);

            notification.success({
                message: response.data.message
            });
        } catch (err) {
            commit('importContactReadAllErr', err);
        }
    },

    async importContactRun({commit}, id) {
        try {
            commit('importContactRunBegin');
            const response = await DataService.post('/import/contacts/run/' + id);
            commit('importContactRunSuccess', response.data.data);

            notification.success({
                message: response.data.message
            });
        } catch (err) {
            commit('importContactRunErr', err);
        }
    },

    async importReadAll({commit}, request) {
        try {
            commit('importReadAllBegin');
            const response = await DataService.get(`/imports?${new URLSearchParams(request).toString()}`);
            commit('importReadAllSuccess', response.data.data);
        } catch (err) {
            commit('importReadAllErr', err);
        }
    },

    async importUserReadAll({commit}, request) {
        try {
            commit('userReadAllBegin');
            const response = await DataService.get(`/users?${new URLSearchParams(request).toString()}`);
            commit('userReadAllSuccess', response.data.data);
        } catch (err) {
            commit('userReadAllErr', err);
        }
    },

    async importDetailReadAll({commit}, request) {
        commit('importDetailReadAllBegin');
        const id = request.id;
        delete request.id;
        await DataService.get(`/import/contacts/${id}?${new URLSearchParams(request).toString()}`).then((response) => {
            commit('importDetailReadAllSuccess', response.data.data);
        }).catch((err) => {
            commit('importDetailReadAllErr', err);
        });
    }

};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
  };